var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.client_id
    ? _c("input", {
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.client_id }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }